import {
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@mui/material";
import React from "react";
import { ActivityLogContext } from "../context/activityLogContext";
import CustomPagination from "../../../components/pagination/customPagination";
import ActivityLogTableHead from "./activityLogTableHead";
import ActivityLogRow from "./activityLogRow";

const ActivityLogTable = (): React.JSX.Element => {
  const {
    loading,
    truncated,
    entries,
    visibleEntries,
    pageEntries,
    pagination,
    setPagination,
  } = React.useContext(ActivityLogContext);

  if (loading) {
    return (
      <Stack role="status" direction="row" spacing={2} justifyContent="center" sx={{ my: 4 }}>
        <CircularProgress size={24} />
        <Typography>Protokoll wird geladen …</Typography>
      </Stack>
    );
  }

  if (entries.length === 0) {
    return <Typography sx={{ my: 4, textAlign: "center" }}>Keine Einträge im gewählten Zeitraum.</Typography>;
  }

  if (visibleEntries.length === 0) {
    return <Typography sx={{ my: 4, textAlign: "center" }}>Keine Einträge für diese Filter.</Typography>;
  }

  return (
    <>
      {truncated && (
        <Typography role="status" sx={{ mb: 1, fontWeight: 600 }}>
          Es werden nur die neuesten 5.000 Einträge angezeigt. Bitte den Zeitraum eingrenzen.
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {visibleEntries.length} von {entries.length} Einträgen
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" aria-label="Protokoll">
          <ActivityLogTableHead />
          <TableBody>
            {pageEntries.map((entry) => (
              <ActivityLogRow key={entry.id} entry={entry} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        items={visibleEntries}
        paginationSettings={pagination}
        setPaginationSettings={setPagination}
      />
    </>
  );
};

export default ActivityLogTable;
